import { useEffect } from "react";
import { Modal } from "react-bootstrap";

/**
 * Full-screen image viewer. Arrow keys step through, Escape closes (the
 * Modal handles Escape and focus trapping).
 */
function Lightbox({ images, index, onClose, onIndexChange }) {
  const open = index !== null;
  const count = images.length;

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "ArrowRight") onIndexChange((index + 1) % count);
      if (e.key === "ArrowLeft") onIndexChange((index - 1 + count) % count);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, index, count, onIndexChange]);

  const image = open ? images[index] : null;

  return (
    <Modal
      show={open}
      onHide={onClose}
      centered
      size="xl"
      className="n1-lightbox"
      aria-label="Image viewer"
    >
      {image && (
        <Modal.Body className="p-0 position-relative">
          <img src={image.src} alt={image.alt} className="n1-lightbox-img" />
          <div className="n1-lightbox-bar">
            <button
              type="button"
              className="n1-lightbox-btn"
              onClick={() => onIndexChange((index - 1 + count) % count)}
              aria-label="Previous image"
            >
              ‹
            </button>
            <span className="small">
              {image.caption}
              <span className="text-muted ms-2">
                {index + 1} / {count}
              </span>
            </span>
            <button
              type="button"
              className="n1-lightbox-btn"
              onClick={() => onIndexChange((index + 1) % count)}
              aria-label="Next image"
            >
              ›
            </button>
          </div>
          <button
            type="button"
            className="n1-lightbox-close"
            onClick={onClose}
            aria-label="Close image viewer"
          >
            ×
          </button>
        </Modal.Body>
      )}
    </Modal>
  );
}

export default Lightbox;
